import React, { FC, useState } from 'react';
import { BASE_URL } from '../../api/config';
import AsyncImage from '../../components/AsyncImage/AsyncImage';
import Form from '../../components/Form/Form';
import Tooltip from '../../components/Tooltip/Tooltip';
import { BroadcasterT } from '../../models/models';
import { useAppSelector } from '../../store/hooks';
import { selectShareToken } from '../../store/selectors/appSelectors';
import getImageLink from '../../utils/helpers/getImageLink';
import { isMobileOrTablet } from '../../utils/helpers/mediaQueries';
import usePopup from '../../utils/hooks/usePopup';

import styles from './selectBroadcasters.module.scss';

type SelectBroadcastersBodyPropTypes = {
    allBroadcasters: BroadcasterT[],
    selectedBroadcasters: BroadcasterT[],
    handleSelect: (selectedBroadcasters: number[]) => void
};

const SelectBroadcastersBody: FC<SelectBroadcastersBodyPropTypes> = (props) => {
    const { allBroadcasters, selectedBroadcasters, handleSelect } = props;
    const [selected, setSelected] = useState(selectedBroadcasters.map(({ Id }) => Id));
    const shareToken = useAppSelector(selectShareToken);
    const { removePopup } = usePopup();

    const selectBroadcaster = (id: number) => {
        if (isNaN(id)) {
            return;
        }
        const existingSet = new Set(selected);

        if (existingSet.has(id)) {
            existingSet.delete(id);
        } else {
            existingSet.add(id);
        }
        setSelected([...existingSet as any]);
    };

    const handleSubmit = (data: any) => {
        handleSelect(selected);
        removePopup();
    };

    return (
        <div>
            <ul className={styles.broadcasterList}>
                {allBroadcasters?.map(({ Id, Name }) => (
                    <li
                        key={Id}
                        className={selected.some(id => id === Id) ? styles.selected : ''}
                        onClick={() => selectBroadcaster(Id)}
                    >
                        <Tooltip text={Name} delayShow={100}>
                            <AsyncImage link={getImageLink({ id: Id, shareToken })} />
                        </Tooltip>
                        {isMobileOrTablet() && (
                            <span className={styles.mobileTitle}>{Name}</span>
                        )}
                    </li>
                ))
                }
            </ul >
            <Form onSubmit={handleSubmit} fields={[]} formID='select-broadcasters' />
        </div>
    );
};

export default SelectBroadcastersBody;